import { styled } from '@innowise-group/mui-kit';

export const OptionWrapper = styled.span``;
export const SalaryValue = styled.span``;
export const SalaryComment = styled.span`
  color: ${({ theme }) => theme.palette.general.darkGrey[40]};
`;
